/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Waffo_TitleInputs */

const en_admin_settings_groups_waffo_title = /** @type {(inputs: Admin_Settings_Groups_Waffo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waffo Pancake`)
};

/**
* | output |
* | --- |
* | "Waffo Pancake" |
*
* @param {Admin_Settings_Groups_Waffo_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_waffo_title = /** @type {((inputs?: Admin_Settings_Groups_Waffo_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Waffo_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_waffo_title(inputs)
});
export { admin_settings_groups_waffo_title as "admin.settings.groups.waffo.title" }